import { BaseService } from "@/app/old/desktop/shared/services/";

class API extends BaseService {
  constructor() {
    super(null, "tags");
  }
}
export const vaultTagService = new API();
